// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"650":"8b4283ce","779":"9b208061"}[chunkId] + ".chunk.css";
};